/** @jsx jsx */
import { Flex, Box, Label, SemiTitle } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';
import { Trans } from '@lingui/macro';

export default function FacetBox({ title, multiSelect, children, ...rest }) {
  return (
    <Box
      sx={{ borderTop: 1, borderColor: 'border', paddingBottom: 4 }}
      {...rest}
    >
      <Flex sx={{ justifyContent: 'space-between', alignItems: 'baseline' }}>
        <SemiTitle sx={{ marginTop: 2, marginBottom: 4 }}>{title}</SemiTitle>
        {multiSelect && (
          <Label
            variant="small"
            sx={{ color: 'lighterText', marginTop: 3, marginLeft: 3 }}
          >
            <Trans>Select multiple</Trans>
          </Label>
        )}
      </Flex>
      {children}
    </Box>
  );
}
